import React from "react";
import { Lock } from "lucide-react";
import { money } from "@/lib/format";

// "Approved, frozen at $X": the price of record cannot move without a person confirming it voids the approval.
export function FrozenBadge({ bid, compact = false, testid = "frozen-badge" }) {
  if (!bid) return null;
  const frozen = bid.frozen ?? (bid.approval_status === "approved" || bid.send_approved || bid.status === "sent" || bid.proposal_source === "provided");
  if (!frozen) return null;
  const total = bid.approved_total ?? bid.stored_total;
  const label = bid.status === "sent" ? "Sent" : "Approved";
  return (
    <span data-testid={testid} title="This price is on record. Any change that moves the total asks first and voids the approval; nothing automatic can change it."
      className={`inline-flex items-center gap-1 rounded-full border border-emerald-200 bg-emerald-50 text-emerald-800 whitespace-nowrap ${compact ? "text-[10px] px-1.5 py-0.5" : "text-[11px] px-2 py-0.5"}`}>
      <Lock className="w-3 h-3" /> {label}, frozen{total != null ? ` at ${money(total)}` : ""}
    </span>
  );
}
